// eslint-disable-next-line import/prefer-default-export
export const RequestStatus = Object.freeze({
    Offered: 0,
    Submitted: 1,
    Approved: 2,
    Refused: 3,
    OfferRetracted: 4,
    RequestRetracted: 5,
    Expired: 6,
    Pending: 7,
    Declined: 8,
    AutoRetracted: 9,
    RetractedSubmitted: 10
});